
<template>
    <header id="header" data-plugin-options="{'stickyEnabled': true, 'stickyEnableOnBoxed': true, 'stickyEnableOnMobile': false, 'stickyStartAt': 45, 'stickySetTop': '-45px', 'stickyChangeLogo': true}">
        <div class="header-body">
            <div class="header-container container">
                <div class="header-row">
                    <div class="header-column">
                        <div class="header-row">
                            <div class="header-logo">
                                <router-link :to="{name:'home'}">
                                    <img alt="Arte-Contemporary" data-sticky-width="150" data-sticky-height="66" data-sticky-top="25" src="/frontend/img/logo-arte.png" width="200" height="88" class="img-fluid">
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="header-column justify-content-end">
                        <div class="header-row pt-3">
                            <div class="header-nav-features">
                                <div class="header-nav-feature header-nav-features-cart d-inline-flex ms-2">
                                    <router-link :to="{name:'ShoppingCart'}" class="header-nav-features-toggle">
                                        <img src="/frontend/img/icons/icon-cart.svg" width="14" alt="" class="header-nav-top-icon-img">
                                        <span class="cart-info">
                                            <span class="cart-qty">{{ (typeof $parent.shoppingCart.items != 'undefined' )? $parent.shoppingCart.items.length : 0 }}</span>
                                        </span>
                                    </router-link>
                                </div>
                                <!-- Perfil usuario -->
                                <div v-if="$cookies.isKey('jwt')" class="header-nav-feature header-nav-features-cart d-inline-flex ms-2">
                                    <router-link :to="{name:'UserProfile'}">
                                        <i class="fas fa-user header-nav-top-icon"></i>
                                    </router-link>
                                </div>
                                <!-- Iconos login / logout -->
                                <div v-else class="header-nav-feature header-nav-features-cart d-inline-flex ms-2">
                                    <router-link :to="{name:'login'}">
                                        <i class="fa fa-user header-nav-top-icon"></i>
                                    </router-link>
                                </div>
                                <div v-if="$cookies.isKey('jwt')" class="header-nav-feature header-nav-features-cart d-inline-flex ms-2">
                                    <a href="javascript:void(0)" @click="$parent.logout">
                                        <i class="fa fa-sign-out header-nav-top-icon"></i>
                                    </a>
                                </div>
                            </div>
                            <nav class="header-nav-top" style="padding-left:15px;">
                                <ul class="nav nav-pills">
                                    <li class="nav-item " v-if="$cookies.isKey('jwt') && ($parent.user.role_id === 1 || $parent.user.role_id === 3)">
                                       <a href="/admin" class="nav-link ps-0" >{{ $t('hi.admin_panel') }}</a>
                                    </li>
                                    <li class="nav-item dropdown nav-item-left-border-remove nav-item-left-border-md-show">
                                        <a class="nav-link" href="#" role="button" id="dropdownLanguage" data-target="#languageSelector" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span v-if="$i18n.locale == 'en'">
                                                <img src="/frontend/img/blank.gif" class="flag flag-gb" alt="English" /> English
                                            </span>
                                            <span v-if="$i18n.locale == 'es'">
                                                <img src="/frontend/img/blank.gif" class="flag flag-es" alt="Español" /> Español
                                            </span>
                                            <span v-if="$i18n.locale == 'ca'">
                                                <img src="/frontend/img/blank.gif" class="flag flag-catalonia" alt="Català" /> Català
                                            </span>
                                            <i class="fas fa-angle-down"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdownLanguage" id="languageSelector">
                                            <a v-if="$i18n.locale !== 'es'" class="dropdown-item" href="javascript:void(0);" @click="$parent.updateLocale('es')"><img src="/frontend/img/blank.gif" class="flag flag-es" alt="Español" /> Español</a>
                                            <a v-if="$i18n.locale !== 'en'" class="dropdown-item" href="javascript:void(0);" @click="$parent.updateLocale('en')"><img src="/frontend/img/blank.gif" class="flag flag-gb" alt="English" /> English</a>
                                            <a v-if="$i18n.locale !== 'ca'" class="dropdown-item" href="javascript:void(0);" @click="$parent.updateLocale('ca')"><img src="/frontend/img/blank.gif" class="flag flag-catalonia" alt="Català" /> Català</a>
                                        </div>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-row">
                            <b-navbar toggleable="lg" class="header-nav pt-1">
                                <div class="header-nav-main">
                                    <b-collapse id="mainMenu" is-nav>
                                        <b-nav-item-dropdown :active="['SulptureParkGallery','VideoTour','FindUs','RapitaEbroDelta','RapitaEbre'].includes($route.name)"
                                                             :text="$t('hi.sculpture_park')"
                                                             toggle-class="nav-link-custom">
                                            <b-dropdown-item :to="{name:'SulptureParkGallery'}" class="goTO">
                                                {{ $t('hi.sculpture_park_gallery') }}
                                            </b-dropdown-item>
                                            <b-dropdown-item :to="{name:'VideoTour'}" class="goTO">
                                                {{ $t('hi.video_tour') }}
                                            </b-dropdown-item>
                                            <b-dropdown-item :to="{name:'FindUs'}" class="goTO">
                                                {{ $t('hi.find_us') }}
                                            </b-dropdown-item>
<!--                                            <b-dropdown-item :to="{name:'RapitaEbroDelta'}" class="goTO">
                                                {{ $t('hi.rapita_ebro_delta') }}
                                            </b-dropdown-item>-->
                                            <b-dropdown-item :to="{name:'rapitaEbreFrontend'}" class="goTO">
                                                {{ $t('hi.rapita_ebro_delta') }}
                                            </b-dropdown-item>
                                            <b-dropdown-item :to="{name:'photographyCompetitionFrontend'}" class="goTO">
                                                {{ titlepc }}
<!--                                               {{ $t('hi.photography_competition') }}-->
                                            </b-dropdown-item>
                                        </b-nav-item-dropdown>
                                        <b-nav-item-dropdown :active="['exhibitionsListFrontend','RentPark'].includes($route.name)"
                                                             :text="$t('hi.exhibitions')"
                                                             toggle-class="nav-link-custom">
                                            <b-dropdown-item :to="{name:'exhibitionsListFrontend'}" class="goTo">
                                                {{ $t('hi.current_exhibitions_cultural_program') }}
                                            </b-dropdown-item>
                                            <b-dropdown-item :to="{name:'RentPark'}" class="goTO">
                                                {{ $t('hi.private_corporate_hire') }}
                                            </b-dropdown-item>
                                        </b-nav-item-dropdown>
                                        <b-nav-item :active="['authorsListFrontend'].includes($route.name)" :to="{name:'authorsListFrontend'}">
                                            {{ $t('hi.authors') }}
                                        </b-nav-item>
                                        <b-nav-item :active="['ContactFrontend'].includes($route.name)" :to="{name:'ContactFrontend'}">
                                            {{ $t('hi.contact') }}
                                        </b-nav-item>
                                        <b-nav-item class="sbtn" :active="['shopFrontend','categoriesListFrontend','artworksViewFrontend'].includes($route.name)" :to="{name:'categoriesListFrontend'}">
                                            {{ $t('hi.purchasing_arte-pieces') }}
                                        </b-nav-item>
                                        <b-nav-item class="sbtn" :active="['bookingsFrontend'].includes($route.name)" :to="{name:'bookingsFrontend'}">
                                            {{ $t('hi.tickets') }}
                                        </b-nav-item>
                                    </b-collapse>
                                </div>
                                <b-navbar-toggle target="mainMenu"></b-navbar-toggle>
                            </b-navbar>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

</template>
<script>
export default {
    name: "Navbar",

    data(){
        return{
            titlepc: "",
            item: {
               translations:[{locale:this.$i18n.locale}]
            }
        };
    },
    async created() {
        this.runquery()
        this.get()

    },
    methods:{
        async get() {
            let self = this;
            //console.log(this.$i18n.locale)
            await self.axios.get('/api/photography-competition/1')
                .then(response=>{
                    self.item = response.data;
                    self.titlepc = this.item.translations.find(o=>o.locale==this.$i18n.locale).title

                })
                .catch(error=>{
                    console.error(error)
                })
        },
        runquery(){

            $(function (){
                $('body')
                    .on('click','#dropdownLanguage',function (){
                        let target = $(this).attr('data-target');
                        if($(target).is(':visible')){
                            $(target).slideUp();
                            $(target).removeAttr("style");
                        }
                        else{
                            $(target).slideDown();
                            $(target).css({'transform': 'translate(0px, 38px)'});
                        }
                    })
                    .on('click','.dropdown-toggle', function (){
                        let target = $(this).attr('data-target');
                        $('body').find('.dropdown-toggle').each(function (){
                            let target2 = $(this).attr('data-target');
                            if($(target2).is(':visible')){
                                $(target2).slideUp();
                            }
                        })
                        if($(target).is(':visible')){
                            $(target).slideUp();
                        }
                        else{
                            $(target).slideDown();

                        }
                    })
                    .on('click','.header-btn-collapse-nav',function (event){
                        event.preventDefault();
                        let target = $(this).attr('data-target');
                        if($(target).is(':visible')){
                            $(target).slideUp();
                            $(target).removeAttr("style");
                            $('.header-body').removeAttr("style");
                        }
                        else{
                            $(target).slideDown(250);
                            $(target).css({'transform': 'translate(0px, 38px)'});
                        }
                        $(target).find(`.dropdown-toggle`).each(function (){
                            let target2 = $(this).attr('data-target');
                            if($(target2).is(':visible')){
                                $(target2).slideUp();
                                $(target).removeAttr("style");
                            }
                        })
                    })
                    .on('click','#mainMenu .goTO', function (){
                        if($('#mainMenu').is(':visible')){
                            $('body').find('.dropdown-toggle').each(function (){
                                let target2 = $(this).attr('data-target');
                                if($(target2).is(':visible')){
                                    $(target2).slideUp();
                                    $(target2).removeAttr("style");
                                }
                            })
                            $('#mainMenu').slideUp();
                            $('#mainMenu').removeAttr("style");
                            $('.header-body').removeAttr("style");
                        }
                    });
            });
        }
    }

};

</script>

<style scoped>

</style>
